module.exports = __webpack_public_path__ + "static/media/cutemixer_promo.069c3b10.gif";